<template>
  <div class="box-unlock-title flex flex-col justify-center"><slot></slot></div>
</template>

<script>
export default {
  name: "BoxUnlockTitle"
};
</script>

<style scoped>
.box-unlock-title {
  height: 8.624rem;
  flex: 0 0 8.624rem;
}
@media screen and (min-height: 1024px) {
  .box-unlock-title {
    height: 9.856rem;
    flex: 0 0 9.856rem;
  }
}
</style>
